import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';

interface VibrationStore {
    isVibrationEnabled: boolean;
    setVibrationEnabled: (isEnabled: boolean) => void;
}

export const useVibration = create<VibrationStore>()(
    devtools(
        immer((set, _) => ({
            isVibrationEnabled: true,
            setVibrationEnabled: (isEnabled: boolean) => {
                set({ isVibrationEnabled: isEnabled });
            },
        })),
    ),
);
